
export const API_DOMAIN = process.env.REACT_APP_API_URL;